<button mat-mini-fab (click)="toggleEditMode()" class="admin-theme" aria-label="Editiermodus umschalten">
  <mat-icon>{{ isEditMode() ? 'visibility' : 'edit' }}</mat-icon>
</button>
